import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getPlantsRegionSlice = createApi(`GetPlantsRegionSlice`,"GET");

const GetPlantsRegionSlice = createSlice({
  name: 'GetPlantsRegionSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlantsRegionSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlantsRegionSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPlantsRegionSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetPlantsRegionSlice.reducer;